import { action } from "satcheljs";
import { addDatapointConfig } from "owa-analytics-actions";
import type { OutlookFavoriteKind } from "owa-favorites-types";
import type { MailboxInfo } from "owa-client-types";

export interface UpdateFavoriteCompletedActionMessage {
    favoriteKind: OutlookFavoriteKind;
    mailboxInfo?: MailboxInfo;
}
export const updateFavoriteCompleted: (favoriteKind: OutlookFavoriteKind, mailboxInfo?: MailboxInfo) => UpdateFavoriteCompletedActionMessage = action("updateFavoriteCompleted", (favoriteKind: OutlookFavoriteKind, mailboxInfo?: MailboxInfo): UpdateFavoriteCompletedActionMessage => addDatapointConfig("UpdateFavoriteCompleted", mailboxInfo, {
    customData: {},
}, { favoriteKind }));
